import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const PortPage = lazy(() => import('./PortPage'));

const PortPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/ports',
         element: <PortPage />,
      },
   ],
};

export default PortPageConfig;
